export const Shadows = {
    primary: {
        boxShadow: '0px 3px 20px 0px rgb(2,141,154,0.1)',
    },
    secondary: {
        boxShadow: '0px 10px 20px 0px rgb(2,141,154,0.25)',
    }
};
